

export class Advertising {


    constructor() {
        this.init();
    }

    init() {
        this.setCloseAdvEvent();
    }

    setCloseAdvEvent() {
        const adSticky = $('.ad-init--sticky');
        if (adSticky.length
            && $('.ad-close-button').length) {

            adSticky.find('.ad-close-button').on('click', function () {
                adSticky.remove();
            });

            // Por problemas con IOS lo desactivamos --> https://mgr.bitban.com/issues/102836
            if (this.getMobileOS() === 'iOS') {
                adSticky.remove();
            }
        }
    }

    getMobileOS() {
        const ua = window.navigator.userAgent;
        if (/android/i.test(ua)) {
            return 'Android';
        }

        if (/iPad|iPhone|iPod/.test(ua)
            || (window.navigator.platform === 'MacIntel'
                && window.navigator.maxTouchPoints > 1)) {
            return 'iOS';
        }

        return 'Other';
    }
}
